import {
    HOME_CHANGE_DRAWER_STATE
} from './actionTypes';

export function handleChange(state) {
    return {
        type: HOME_CHANGE_DRAWER_STATE,
        state
    }
}